import api from "../../index";

export const GetSignatureApi = () => api.post('signature-report');